/* eslint-disable */
import React, { useEffect, useState } from "react";

import { useLivePrice } from "@/api/digital-gold/livePrice";
import { useBuyRedirectStore } from "@/api/digital-gold/store/buyGoldRedirectionStore";
import { BuyStepName, CurrentStepNames } from "@/utils/constants/digital-gold";
import { useRouter } from "next/router";
import routes from "@/routes/routes.json";
import { useNotificationStore } from "@/common/store";

export const Timer = (props: {
  setLivePrice?: any;
  flowName?: string;
  refreshRequiredPostTime?: boolean;
  checkoutPage?:string
}) => {
  const { setLivePrice, flowName, refreshRequiredPostTime, } = props;
  const [seconds, setSeconds] = useState(240); // value in seconds
  const [setBuyStep] = useBuyRedirectStore((state) => [state.setBuyStep]);
  const router = useRouter();
  const { addNotification } = useNotificationStore();

  const { livePriceData, refetch } = useLivePrice();

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    flowName === "BUY"
      ? setLivePrice(livePriceData.buyGoldRate)
      : setLivePrice(livePriceData.saleGoldRate);
  }, [livePriceData]);


  // TODO : why we need request timeout and window location reload in below code
  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      if (refreshRequiredPostTime) {
        addNotification({
          type: "error",
          title: "Request Time Out",
        });
        window.location.reload();
      } else {
        refetch();
        flowName === "BUY"
          ? setLivePrice(livePriceData.buyGoldRate)
          : setLivePrice(livePriceData.saleGoldRate);
          addNotification({
            type: "error",
            title: "Request Time Out",
          });
        setBuyStep(BuyStepName.buyLanding);
        setSeconds(240);
      }
    }
  }, [seconds]);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <>
      {minutes.toString().padStart(2, "0")}:
      {remainingSeconds.toString().padStart(2, "0")}
      {/* {minutes}: 
      {remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} */}
    </>
  );
};
